// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3lDgj","large":"styles_large__2cirm"};